module.exports = __webpack_public_path__ + "img/benefit_01.c5976e2b.svg";